import React from 'react';

const Servicios = () => {
  const servicios = [
    {
      title: 'Asesoramiento Societario',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
        </svg>
      ),
      items: [
        'Constitución de Sociedades (SA – SRL)',
        'Análisis de la Elección Societaria',
        'Inscripción en los Organismos de Control'
      ]
    },
    {
      title: 'Personas Humanas',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
        </svg>
      ),
      items: [
        'Asesoramiento e Inscripción',
        'Análisis y Seguimiento Contable',
        'Liquidación Impositiva Mensual (IVA, IIBB, Previsional)',
        'Liquidación Impositiva Anual (Ganancias, Bs Personales)'
      ]
    },
    {
      title: 'Personas Jurídicas',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
        </svg>
      ),
      items: [
        'Asesoramiento Impositivo',
        'Contabilidad Mensual y Anual (EECC)',
        'Liquidación impositiva Mensual (IVA, IIBB, Previsional)',
        'Liquidación impositiva Anual (Ganancias)'
      ]
    },
    {
      title: 'Servicios para Auditorías',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      ),
      items: [
        'Control Interno',
        'Auditoría Interna',
        'Auditoría Externa',
        'Informes'
      ]
    }
  ];

  return (
    <section id="servicios" className="py-16 sm:py-24 bg-[#F8FBFD]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-[#001F3F] mb-12 sm:mb-16">
          Nuestros servicios
        </h2>

        <div className="grid sm:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {servicios.map((servicio, index) => (
            <div
              key={index}
              className="bg-white rounded-b-2xl p-8 border-t-4 border-[#3799C4] shadow-md"
            >
              {/* Icon */}
              <div className="text-[#3799C4] mb-6">
                {servicio.icon}
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-[#3799C4] mb-6">
                {servicio.title}
              </h3>

              {/* Items */}
              <ul className="space-y-3">
                {servicio.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-3 text-sm text-gray-700">
                    <span className="text-gray-400 mt-1">•</span>
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicios;
